import { render, staticRenderFns } from "./ConfirmDlgWithBlackBoards.vue?vue&type=template&id=1170261d&"
import script from "./ConfirmDlgWithBlackBoards.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDlgWithBlackBoards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports